import { Deserializable } from '../../protocols/deserializable';
import { EmployerSubmissionTypeEnum } from '../../users/enum/employer-submission-type.enum';
import { SubmissionStatusIdEnum } from '../../enum/shared/submission-status-id.enum';
import { MemberSubmissionStatus } from '../member-submission-status';
import { SubmissionComment } from '../submission-comment';
import { PortalTypeIdEnum } from '../../enum/shared/portal-type-id.enum';
import { SubmissionAttachment } from '../submission-attachment';
import { UpdateEmployerAddressSubmission } from './update-employer-address-submission';
import { UpdateEmployerContactsSubmission } from './update-employer-contacts-submission';
import { SubmissionStatusPill } from '../../shared/submission-status-pill';
import * as moment from 'moment/moment';

export class EpEmployerSubmission implements Deserializable {
  public id!: number;
  public employerId!: number;
  public employerName!: string;
  public submissionTypeId!: EmployerSubmissionTypeEnum;
  public submissionTypeName!: string;
  public statusId!: SubmissionStatusIdEnum;
  public status!: MemberSubmissionStatus;
  public comments!: SubmissionComment[];
  public idPrefix!: string;
  public idSuffix!: string;
  public submittedDate!: string;
  public expirationDate!: string;
  public lastStatusUpdateDate!: string;
  public createdInPortalTypeId!: PortalTypeIdEnum;
  public createdByEmployerUserName!: string;
  public completedDate!: string | null;
  public createdDate!: string | null;
  public attachments!: SubmissionAttachment[];
  public updateAddressSubmissionId!: string;
  public updateAddressSubmission!: UpdateEmployerAddressSubmission;
  public updateContactsSubmissionId!: string;
  public updateContactsSubmission!: UpdateEmployerContactsSubmission;

  // Not From API
  public submissionId!: string;
  public formattedExpirationDate!: string;
  public expiringSoon!: boolean;
  public statusPill!: SubmissionStatusPill;
  public completedDateString!: string;
  public createdDateString!: string;

  public canUploadFiles(): boolean {
    return this.statusId === SubmissionStatusIdEnum.Submitted || this.statusId === SubmissionStatusIdEnum.InReview;
  }

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    this.submissionId = this.buildSubmissionId();

    if (!!this.comments) {
      this.comments = Deserialize?.arrayOf(SubmissionComment, this.comments);
    }
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(MemberSubmissionStatus, this.status);
      this.statusPill = new SubmissionStatusPill(this.id, this.status.name, this.statusId, this.status.name);
    }
    if (!!this.attachments) {
      this.attachments = Deserialize?.arrayOf(SubmissionAttachment, this.attachments);
    }

    if (!!this.updateAddressSubmission) {
      this.updateAddressSubmission = Deserialize?.instanceOf(
        UpdateEmployerAddressSubmission,
        this.updateAddressSubmission
      );
    }

    if (!!this.expirationDate) {
      this.formattedExpirationDate = moment(this.expirationDate).format('MMMM D, YYYY');
      // if the submission is expiring within the next 10 days, set expiringSoon to true
      this.expiringSoon = moment(this.expirationDate).diff(moment(), 'days') <= 10;
    }

    if (!!this.completedDate) {
      this.completedDateString = this.completedDate;
    }

    if (!!this.createdDate) {
      this.createdDateString = this.createdDate;
    }
  }

  private buildSubmissionId(): string {
    // Submission IDs should be 8 characters long, padded with leading zeros
    const paddedId = this.id.toString().padStart(8, '0');
    return `${this.idPrefix}-${paddedId}-${this.idSuffix}`;
  }
}
